// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fbO0","rootNoMargin":"styles_rootNoMargin__141w1"};